import { get, post, patch } from '@/helpers/httpHandler';

export default {
  namespaced: true,

  state: {
    form: {}
  },

  getters: {
    RETRIEVED_FORM: store => {
      return store.form;
    }
  },

  actions: {
    getList: (_, { pageNumber, itemsPerPage, sortBy = '', orderBy = '' }) =>
      get(
        '/forms?page=' +
          pageNumber +
          '&per_page=' +
          itemsPerPage +
          '&order_by=' +
          orderBy +
          '&sort_by=' +
          sortBy
      ),

    retrieve: (_, id) => get(`/forms/${id}`),
    retrieveFormApps: (_, id) => get(`/forms/${id}/applications`),
    store: (_, data) => post('/forms', data),
    update: (_, data) => patch(`/forms/${data.id}`, data),
    updateFormApp: (_, data) => patch(`/forms/tile/${data.id}/email`, data)
  }
};
